<div [ngClass]="mainContainerClass">
  <ng-container *ngFor="let row of rows; let i = index">
    <div [ngClass]="childContainerClass" *ngIf="row.visible">
      <ng-template [ngTemplateOutlet]="row.templateRef"></ng-template>
    </div>
  </ng-container>
</div>
